/* Gulabo Jaipur theme — storefront interactions */
(function () {
  var routes = window.routes || {};
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- money ---------- */
  function withComma(n, dec) { n = (n || 0).toFixed(dec); var p = n.split('.'); var gi = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return p[1] ? gi + '.' + p[1] : gi; }
  function formatMoney(cents) {
    var v = cents / 100;
    var s = v.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return '₹' + s;
  }

  /* ---------- panels ---------- */
  var scrim = $('#scrim');
  function openPanel(id) { var el = $('#' + id); if (!el) return; el.classList.add('open'); if (scrim) scrim.classList.add('show'); document.body.style.overflow = 'hidden'; }
  function closeAll() { $all('.drawer,.search-overlay,.modal').forEach(function (d) { d.classList.remove('open'); }); if (scrim) scrim.classList.remove('show'); document.body.style.overflow = ''; var mm = $('#mmenu'); if (mm) mm.classList.remove('open'); }
  if (scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) { e.preventDefault(); closeAll(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  var openSearch = $('#openSearch'); if (openSearch) openSearch.addEventListener('click', function (e) { e.preventDefault(); openPanel('searchOverlay'); setTimeout(function () { var i = $('#searchInput'); if (i) i.focus(); }, 60); });
  var openWish = $('#openWish'); if (openWish) openWish.addEventListener('click', function (e) { e.preventDefault(); renderWish(); openPanel('wishDrawer'); });
  var openCart = $('#openCart'); if (openCart) openCart.addEventListener('click', function (e) { e.preventDefault(); openPanel('cartDrawer'); });
  var dataOpenSearch = document.querySelector('[data-open="search"]'); if (dataOpenSearch) dataOpenSearch.addEventListener('click', function (e) { e.preventDefault(); closeAll(); openPanel('searchOverlay'); setTimeout(function () { var i = $('#searchInput'); if (i) i.focus(); }, 60); });

  /* ---------- mobile menu ---------- */
  var burger = $('#burger'), mclose = $('#mclose'), mm = $('#mmenu');
  if (burger) burger.addEventListener('click', function () { mm.classList.add('open'); });
  if (mclose) mclose.addEventListener('click', function () { mm.classList.remove('open'); });

  /* ---------- header mode ---------- */
  var head = $('#head');
  var indexHero = document.body.classList.contains('template-index') && $('.hero');
  function setHeader() { if (!head) return; if (indexHero) { head.classList.toggle('solid', window.scrollY > 60); } else { head.classList.add('solid'); } }
  window.addEventListener('scroll', setHeader, { passive: true }); setHeader();

  /* ---------- reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.1 });
    $all('.reveal').forEach(function (el) { io.observe(el); });
  } else { $all('.reveal').forEach(function (el) { el.classList.add('in'); }); }

  /* ---------- rails ---------- */
  $all('.rail-nav').forEach(function (b) {
    b.addEventListener('click', function () {
      var rail = $('#' + b.dataset.rail); if (!rail) return;
      var c = rail.querySelector('.card'); var dx = (c ? c.offsetWidth : 240) + 20;
      rail.scrollBy({ left: b.classList.contains('next') ? dx * 2 : -dx * 2, behavior: 'smooth' });
    });
  });

  /* ---------- toast ---------- */
  var toast = $('#wishToast'), toastT;
  function fireToast(msg) { if (!toast) return; toast.textContent = msg; toast.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(function () { toast.classList.remove('show'); }, 1800); }

  /* ---------- cart (AJAX) ---------- */
  function cartCount(n) { var el = $('#cartCount'); if (!el) return; el.textContent = n; el.style.display = n ? 'grid' : 'none'; }
  function renderCart(cart) {
    var wrap = $('#cartItems'); if (!wrap) return;
    if (!cart.items || !cart.items.length) { wrap.innerHTML = '<p class="empty">Your bag is empty.</p>'; }
    else {
      wrap.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image : (it.featured_image && it.featured_image.url) || '';
        return '<div class="drawer-item"><img src="' + img + '" alt=""><div class="di-info"><div class="di-t">' + it.product_title + '</div><div class="di-m">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' · ' : '') + 'Qty ' + it.quantity + '</div><div class="di-p">' + formatMoney(it.final_line_price) + '</div></div><button class="di-rm" data-key="' + it.key + '" aria-label="Remove">×</button></div>';
      }).join('');
    }
    var sub = $('#cartSub'); if (sub) sub.textContent = formatMoney(cart.total_price);
    cartCount(cart.item_count);
  }
  function refreshCart(open) {
    return fetch(routes.cart + '.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); if (open) openPanel('cartDrawer'); })
      .catch(function () { if (open) openPanel('cartDrawer'); });
  }
  function addToCart(id, qty) {
    if (!id) { fireToast('Please choose an option first'); return; }
    return fetch(routes.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { fireToast(res.data && res.data.description ? res.data.description : 'Sorry — that item could not be added'); return; }
        fireToast('🛍  Added to your bag'); refreshCart(true);
      })
      .catch(function () { fireToast('Network issue — please try again'); });
  }
  function changeCart(key, qty) {
    fetch(routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.js-quick-add');
    if (q) { e.preventDefault(); if (q.dataset.id) addToCart(q.dataset.id, Number(q.dataset.qty) || 1); return; }
    var rm = e.target.closest('#cartItems [data-key]');
    if (rm) { e.preventDefault(); changeCart(rm.dataset.key, 0); return; }
  });

  /* ---------- wishlist (localStorage + CRM hook) ---------- */
  var WKEY = 'gulabo_wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function setWish(a) { localStorage.setItem(WKEY, JSON.stringify(a)); wishCount(a.length); }
  function wishCount(n) { var el = $('#wishCount'); if (!el) return; el.textContent = n; el.style.display = n ? 'grid' : 'none'; }
  function inWish(h) { return getWish().some(function (w) { return w.handle === h; }); }
  function renderWish() {
    var wrap = $('#wishItems'); if (!wrap) return; var list = getWish();
    if (!list.length) { wrap.innerHTML = '<p class="empty">No saved items yet. Tap the ♡ on any product.</p>'; return; }
    wrap.innerHTML = list.map(function (w) {
      return '<div class="drawer-item"><img src="' + w.img + '" alt=""><div class="di-info"><div class="di-t">' + w.title + '</div><div class="di-p">' + formatMoney(w.price) + '</div><a class="di-add" href="' + w.url + '">View Product</a></div><button class="di-rm" data-unwish="' + w.handle + '" aria-label="Remove">×</button></div>';
    }).join('');
  }
  function toggleWish(btn) {
    var h = btn.dataset.handle, list = getWish(), i = list.findIndex(function (w) { return w.handle === h; }), added;
    if (i >= 0) { list.splice(i, 1); added = false; } else { list.push({ handle: h, title: btn.dataset.title, price: Number(btn.dataset.price), img: btn.dataset.img, url: btn.dataset.url }); added = true; }
    setWish(list); btn.classList.toggle('saved', added); fireToast(added ? '♥ Added to your Wishlist' : 'Removed from Wishlist');
    /* CRM hook: emit wishlist event to your marketing platform here (added/removed, handle) */
    if (added) document.dispatchEvent(new CustomEvent('gulabo:wishlist:add', { detail: { handle: h } }));
    renderWish();
  }
  document.addEventListener('click', function (e) {
    var w = e.target.closest('.js-wish'); if (w) { e.preventDefault(); toggleWish(w); return; }
    var uw = e.target.closest('[data-unwish]'); if (uw) { e.preventDefault(); var list = getWish().filter(function (x) { return x.handle !== uw.dataset.unwish; }); setWish(list); renderWish(); $all('.js-wish[data-handle="' + uw.dataset.unwish + '"]').forEach(function (b) { b.classList.remove('saved'); }); return; }
  });
  function markWish() { var set = {}; getWish().forEach(function (w) { set[w.handle] = 1; }); $all('.js-wish').forEach(function (b) { if (set[b.dataset.handle]) b.classList.add('saved'); }); wishCount(getWish().length); }

  /* ---------- predictive search ---------- */
  var sInput = $('#searchInput'), sResults = $('#searchResults'), sTimer;
  if (sInput) sInput.addEventListener('input', function () {
    var q = sInput.value.trim(); clearTimeout(sTimer);
    if (!q) { sResults.innerHTML = ''; return; }
    sTimer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (!items.length) { sResults.innerHTML = '<p class="empty">No matches. Try “anarkali”, “pink”, “sharara”.</p>'; return; }
          sResults.innerHTML = items.map(function (p) {
            var img = p.featured_image ? p.featured_image.url : (p.image || '');
            return '<article class="card"><a class="card-media" href="' + p.url + '"><img class="img-a" src="' + img + '" loading="lazy" alt="' + p.title + '"></a><div class="card-info"><h3 class="card-title"><a href="' + p.url + '" style="color:inherit">' + p.title + '</a></h3><p class="card-price"><span class="now">' + (p.price || '') + '</span></p></div></article>';
          }).join('');
        });
    }, 200);
  });

  /* ---------- product page interactions ---------- */
  document.addEventListener('click', function (e) {
    var ah = e.target.closest('.acc-head'); if (ah) { ah.parentElement.classList.toggle('open'); return; }
    var sg = e.target.closest('.js-size-guide'); if (sg) { e.preventDefault(); openPanel('sizeGuide'); return; }
  });

  /* ---------- product gallery: swipe (touch/trackpad/mouse), arrows, keyboard ---------- */
  (function () {
    var wrap = $('#mainImgWrap'); if (!wrap) return;
    var main = $('#mainImg');
    var thumbs = $all('.thumb', $('#thumbs'));
    if (!thumbs.length) return;
    var count = thumbs.length;
    var index = Math.max(0, thumbs.findIndex(function (t) { return t.classList.contains('on'); }));
    var counterEl = $('#galleryCount');
    var prevBtn = $('#galleryPrev'), nextBtn = $('#galleryNext');

    function render(i, animate) {
      index = (i + count) % count;
      var src = thumbs[index].dataset.src;
      if (animate) {
        main.style.opacity = 0;
        setTimeout(function () { main.src = src; main.style.opacity = 1; }, 90);
      } else {
        main.src = src;
      }
      thumbs.forEach(function (t, ti) { t.classList.toggle('on', ti === index); });
      var activeThumb = thumbs[index];
      if (activeThumb && activeThumb.scrollIntoView) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      if (counterEl) counterEl.textContent = (index + 1) + ' / ' + count;
    }

    thumbs.forEach(function (t, ti) { t.addEventListener('click', function () { render(ti, true); }); });
    if (prevBtn) prevBtn.addEventListener('click', function () { render(index - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { render(index + 1, true); });

    if (count > 1) {
      /* Pointer Events cover touch, mouse and pen in one code path — swipe on
         phones/tablets, click-drag on a laptop trackpad or mouse. */
      var startX = 0, startY = 0, dx = 0, dragging = false, pointerId = null;
      var THRESHOLD = 40;

      wrap.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true; pointerId = e.pointerId; startX = e.clientX; startY = e.clientY; dx = 0;
        wrap.classList.add('dragging');
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!dragging || e.pointerId !== pointerId) return;
        dx = e.clientX - startX;
        var dy = e.clientY - startY;
        /* Only claim the gesture once it's clearly horizontal, so a vertical
           swipe still scrolls the page instead of getting hijacked. */
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) { e.preventDefault(); }
      });
      function endDrag(e) {
        if (!dragging || (pointerId !== null && e.pointerId !== pointerId)) return;
        dragging = false; wrap.classList.remove('dragging'); pointerId = null;
        if (Math.abs(dx) > THRESHOLD) { render(dx < 0 ? index + 1 : index - 1, true); }
        dx = 0;
      }
      wrap.addEventListener('pointerup', endDrag);
      wrap.addEventListener('pointercancel', endDrag);
      wrap.addEventListener('pointerleave', function (e) { if (dragging) endDrag(e); });

      /* left/right arrow keys while the gallery has focus or is hovered */
      wrap.setAttribute('tabindex', '0');
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { render(index - 1, true); }
        else if (e.key === 'ArrowRight') { render(index + 1, true); }
      });
    }
  })();

  document.addEventListener('DOMContentLoaded', function () { markWish(); refreshCart(false); });
  markWish(); refreshCart(false);
})();

/* ===== Gulabo mega navigation (v2) ===== */
(function () {
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var head = $('#head');

  /* desktop mega: pure CSS :hover opens/closes; JS handles touch tap-toggle only */
  function anyOpen() { return !!document.querySelector('.gnav-item.open'); }
  function syncHead() { if (head) head.classList.toggle('mega-open', anyOpen()); }
  $all('.gnav-item.has-mega').forEach(function (item) {
    var top = item.querySelector(':scope > a');
    if (top) top.addEventListener('click', function (e) {
      /* first tap opens on touch devices; second tap follows the link */
      if (window.matchMedia('(hover: none)').matches && !item.classList.contains('open')) {
        e.preventDefault();
        $all('.gnav-item.open').forEach(function (o) { o.classList.remove('open'); });
        item.classList.add('open'); syncHead();
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.gnav-item')) { $all('.gnav-item.open').forEach(function (o) { o.classList.remove('open'); }); syncHead(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { $all('.gnav-item.open').forEach(function (o) { o.classList.remove('open'); }); syncHead(); }
  });

  /* sale panel: rotate live discount cards in windows of 4 */
  var grid = $('#gjSaleGrid');
  if (grid) {
    var cards = $all('.gj-sale-card', grid);
    if (cards.length > 4) {
      var start = 0;
      setInterval(function () {
        start = (start + 4) % cards.length;
        cards.forEach(function (c, i) {
          var visible = false;
          for (var k = 0; k < 4; k++) { if ((start + k) % cards.length === i) visible = true; }
          c.classList.toggle('extra', !visible);
          if (visible) { c.classList.remove('swap'); void c.offsetWidth; c.classList.add('swap'); }
        });
      }, 4200);
    }
  }

  /* mobile drawer accordions */
  $all('.gj-md-item > button').forEach(function (b) {
    b.addEventListener('click', function () {
      var it = b.parentElement, was = it.classList.contains('open');
      $all('.gj-md-item.open').forEach(function (o) { o.classList.remove('open'); });
      if (!was) it.classList.add('open');
    });
  });
})();

/* ===== auto-advance rails (celebrity section — changes like the sale panel) ===== */
(function () {
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  $all('.rail[data-autoscroll]').forEach(function (rail) {
    var card = rail.querySelector('.celeb-card, .card'); if (!card) return;
    var paused = false;
    rail.addEventListener('mouseenter', function () { paused = true; });
    rail.addEventListener('mouseleave', function () { paused = false; });
    rail.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    setInterval(function () {
      if (paused || document.hidden) return;
      var max = rail.scrollWidth - rail.clientWidth - 4;
      if (max <= 0) return; /* everything fits — nothing to rotate */
      if (rail.scrollLeft >= max) { rail.scrollTo({ left: 0, behavior: 'smooth' }); }
      else { rail.scrollBy({ left: card.offsetWidth + 20, behavior: 'smooth' }); }
    }, 3800);
  });
})();
